
import React from 'react';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { useNavigate } from 'react-router-dom';
import { aiCandidates } from '@/components/staff/data';

interface AvailableStaffGridProps {
  onSelectCandidate?: (candidateId: number) => void;
}

const AvailableStaffGrid: React.FC<AvailableStaffGridProps> = ({ onSelectCandidate }) => {
  const navigate = useNavigate();

  const handleSelectCandidate = (candidateId: number) => {
    if (onSelectCandidate) {
      onSelectCandidate(candidateId);
    } else {
      navigate(`/app/hiring?candidate=${candidateId}`);
    }
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {aiCandidates.map((candidate) => (
        <Card 
          key={candidate.id}
          className="hover:shadow-md transition-all cursor-pointer"
          onClick={() => handleSelectCandidate(candidate.id)}
        >
          <CardHeader>
            <div className="flex items-center gap-3">
              <div className="text-4xl">{candidate.avatar}</div>
              <div>
                <CardTitle>{candidate.name}</CardTitle>
                <CardDescription className="flex gap-2 mt-1">
                  <Badge className="capitalize">{candidate.role}</Badge>
                  {candidate.role !== "marketing" && (
                    <Badge variant="outline">Coming Soon</Badge>
                  )}
                </CardDescription>
              </div>
            </div>
          </CardHeader>
          <CardContent>
            <p className="text-sm mb-4">{candidate.description}</p>
            <div>
              <div className="text-sm font-medium mb-2">Key Skills:</div>
              <div className="flex flex-wrap gap-1">
                {candidate.skills.slice(0, 3).map((skill, index) => (
                  <Badge key={index} variant="secondary" className="text-xs mb-1">
                    {skill}
                  </Badge>
                ))}
                {candidate.skills.length > 3 && (
                  <Badge variant="secondary" className="text-xs mb-1">
                    +{candidate.skills.length - 3} more
                  </Badge>
                )}
              </div>
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
};

export default AvailableStaffGrid;
